import { formatPrice } from '~/utils/formaters';

export const formatPriceValue = (value: number | string) =>
  formatPrice(value, 0);
export const makeNumber = (val: string) => Number(val.replace(',', ''));
